/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Directory_Ai_Tools_Packs_Per_VideoInputs */

const en_directory_ai_tools_packs_per_video = /** @type {(inputs: Directory_Ai_Tools_Packs_Per_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.price} per standard video`)
};

const zh_directory_ai_tools_packs_per_video = /** @type {(inputs: Directory_Ai_Tools_Packs_Per_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`约 ${i?.price} / 条标准视频`)
};

/**
* | output |
* | --- |
* | "≈ {price} per standard video" |
*
* @param {Directory_Ai_Tools_Packs_Per_VideoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_packs_per_video = /** @type {((inputs: Directory_Ai_Tools_Packs_Per_VideoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Packs_Per_VideoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_packs_per_video(inputs)
	return zh_directory_ai_tools_packs_per_video(inputs)
});
export { directory_ai_tools_packs_per_video as "directory.ai_tools.packs.per_video" }